import api from '@/api/classes';
import store from '@/store';

const createClass = (context, classOptions) => new Promise(((resolve, reject) => {
  api.createClass(classOptions)
    .then((response) => {
      context.commit('SAVE_CLASS', response);
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const checkEmailAvailability = (context, { classId, email }) => new Promise(((resolve, reject) => {
  api.checkEmailAvailability(classId, email)
    .then((response) => {
      resolve((response));
    })
    .catch((error) => {
      reject((error));
    });
}));

const inviteStudents = (context, { classId, invitations }) => new Promise(((resolve, reject) => {
  api.inviteStudents(classId, invitations)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const getClasses = context => new Promise(((resolve, reject) => {
  api.getClasses()
    .then((response) => {
      // context.commit('SAVE_CLASSES', response);
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const getAggregatedSkillStat = (context, classId) => new Promise(((resolve, reject) => {
  api.getAggregatedSkillStat(classId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const setClass = (context, classObj) => new Promise(((resolve, reject) => {
  context.commit('SAVE_CLASS', classObj);
}));

const getStudentsFromClass = (context, { classId, saveState = true }) => new Promise(((resolve, reject) => {
  api.getStudentsFromClass(classId)
    .then((response) => {
      if (saveState) context.commit('SAVE_STUDENTS', response);

      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const moveStudent = (context, { classId, rosterId, newClassId }) => new Promise(((resolve, reject) => {
  api.moveStudent(classId, rosterId, newClassId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const getClassById = (context, classId) => new Promise(((resolve, reject) => {
  api.getClassById(classId)
    .then((response) => {
      context.commit('SAVE_CLASS', response);
      store.commit('settings/SET_LEARNED_LANGUAGE', response.learnedLanguage);
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const removeStudent = (context, { classId, rosterId }) => new Promise(((resolve, reject) => {
  api.removeStudent(classId, rosterId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const setInviteToast = (context, value) => {
  context.commit('SET_INVITE_TOAST', value);
};

const getLatestAssignments = (context, { classId, counter }) => new Promise(((resolve, reject) => {
  api.getLatestAssignments(classId, counter)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const getNextUpTasks = (context, { classId, counter }) => new Promise(((resolve, reject) => {
  api.getNextUpTasks(classId, counter)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const getSuggestedTasks = (context, { classId, counter }) => new Promise(((resolve, reject) => {
  api.getSuggestedTasks(classId, counter)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const getPracticeTasks = (context, classId) => new Promise(((resolve, reject) => {
  api.getPracticeTasks(classId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const updateClass = (context, { classId, settings }) => new Promise(((resolve, reject) => {
  api.updateClass(classId, settings)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const deleteClass = (context, classId) => new Promise(((resolve, reject) => {
  api.deleteClass(classId)
    .then((response) => {
      context.commit('SAVE_CLASSES', response);
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const getUpcomingLessons = (context, classId) => new Promise(((resolve, reject) => {
  api.getUpcomingLessons(classId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const mergeClasses = (context, data) => new Promise(((resolve, reject) => {
  api.mergeClasses(data)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const setClassDeleteToast = (context, value) => {
  context.commit('SET_CLASS_DELETE_TOAST', value);
};

const getOpenAssignments = (context, { classId, page, limit, order, direction }) => new Promise(((resolve, reject) => {
  api.getOpenAssignments(classId, page, limit, order, direction)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

// eslint-disable-next-line
const getClosedAssignments = (context, { classId, page, limit, order, direction }) => new Promise(((resolve, reject) => {
  api.getClosedAssignments(classId, page, limit, order, direction)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const getClassLeaderboard = (context, { classId, limit }) => new Promise((resolve, reject) => {
  api.getClassLeaderboard(classId, limit)
    .then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    });
});

const getClassReport = (context, { classId, interval }) => new Promise((resolve, reject) => {
  api.getClassReport(classId, interval)
    .then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    });
});

const getClassReportOverview = (context, classId) => new Promise((resolve, reject) => {
  api.getClassReportOverview(classId)
    .then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    });
});

const downloadClassRerportPdf = (context, { classId, interval }) => new Promise((resolve, reject) => {
  api.downloadClassRerportPdf(classId, interval)
    .then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    });
});

const getDataStore = (context, accessKey) => new Promise((resolve, reject) => {
  api.getDataStore(accessKey)
    .then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    });
});

const getPreviousChamps = (context, data) => new Promise((resolve, reject) => {
  api.getPreviousChamps(data)
    .then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    });
});

const getAllStudent = context => new Promise((resolve, reject) => {
  api.getAllStudent()
    .then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    });
});

const getClassesDktUser = (context, scope) => new Promise((resolve, reject) => {
  api.getClassesDktUser(scope)
    .then((response) => {
      context.commit('SAVE_CLASSES', response);
      resolve(response);
    }).catch((error) => {
      reject(error);
    });
});

export default {
  createClass,
  checkEmailAvailability,
  inviteStudents,
  getClasses,
  getAggregatedSkillStat,
  setClass,
  getStudentsFromClass,
  moveStudent,
  removeStudent,
  getClassById,
  setInviteToast,
  getLatestAssignments,
  getNextUpTasks,
  getSuggestedTasks,
  getPracticeTasks,
  updateClass,
  deleteClass,
  getUpcomingLessons,
  mergeClasses,
  setClassDeleteToast,
  getOpenAssignments,
  getClosedAssignments,
  getClassLeaderboard,
  getClassReport,
  getClassReportOverview,
  downloadClassRerportPdf,
  getDataStore,
  getPreviousChamps,
  getAllStudent,
  getClassesDktUser
};



// WEBPACK FOOTER //
// ./src/store/modules/classes/actions.js